// extracted by mini-css-extract-plugin
export default {"outer":"ScaleContentToFit_outer__q+fmL","inner":"ScaleContentToFit_inner__OXvix"};